import api from './client'

export interface BugReportRequest {
  description: string
  category?: 'ui' | 'crash' | 'feature' | 'performance' | 'other'
}

export interface BugReportResponse {
  id: number
  status: string
  message: string
}

export async function submitBugReport(
  data: BugReportRequest,
  screenshots?: File[],
  video?: Blob
): Promise<BugReportResponse> {
  const formData = new FormData()

  // Required field
  formData.append('description', data.description)

  // Optional category
  if (data.category) {
    formData.append('category', data.category)
  }

  // Screenshots (up to 3)
  if (screenshots) {
    screenshots.slice(0, 3).forEach((file, index) => {
      formData.append(`screenshot_${index}`, file)
    })
  }

  // Video (1 max)
  if (video) {
    formData.append('video', video, 'recording.webm')
  }

  // Set Content-Type to undefined so axios auto-detects multipart/form-data with boundary
  const response = await api.post<BugReportResponse>('/feedback/bug-report', formData, {
    headers: {
      'Content-Type': undefined,
    },
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  })

  return response.data
}
